import { render } from "./Files.vue?vue&type=template&id=120f4132&scoped=true"
import script from "./Files.vue?vue&type=script&lang=ts"
export * from "./Files.vue?vue&type=script&lang=ts"

import "./Files.vue?vue&type=style&index=0&id=120f4132&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-120f4132"

export default script